var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+", All rights Reserved")])])}
var staticRenderFns = []

export { render, staticRenderFns }